import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  path?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="text-xs text-foreground-500 md:text-sm">
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.path && !isLast ? (
                <Link to={item.path} className="whitespace-nowrap transition-colors hover:text-primary-600">
                  {item.label}
                </Link>
              ) : (
                <span className="whitespace-nowrap text-foreground-700">{item.label}</span>
              )}
              {!isLast && <i className="ri-arrow-right-s-line text-foreground-300" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}